import { Field, Form, Formik } from "formik";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { object, string } from "yup";

import FormError from "../../../../components/FormError";
import LoadingSpinner from "../../../../components/LoadingSpinner/LoadingSpinner";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import { IMPORTER_DETAILS_STEP } from "../../constants";
import useSelectedBomsRequired from "../../hooks/useSelectedBomsRequired";
import useImporterForm from "./useImporterForm";

const schema = object().shape({
  name: string().required("Please enter the importer's name."),
  email: string().email("Please enter a valid email address").required("Please enter the importer's email address."),
  address: string().min(6, "Address must contain at least 6 characters.").required("Please enter the importer's address."),
  phoneNumber: string()
    .min(8, "Phone number must be at least 8 characters long.")
    .matches(/[+0-9]/, "Please enter a valid phone number.")
    .required("Please enter the importer's phone number."),
});

export default function ImporterForm() {
  useSelectedBomsRequired();
  const { loading, initialValues, handleSubmit } = useImporterForm();
  const location = useLocation();

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-2" />
        <div className="col-lg-8">
          <div className="my-5">
            <ProgressBar step={IMPORTER_DETAILS_STEP} />
          </div>
          <div className="mb-5">
            <h1 className="mb-4">Importer&apos;s Data</h1>
            <p>Add your importer&apos;s information.</p>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center align-items-center">
              <LoadingSpinner />
            </div>
          ) : (
            <Formik validationSchema={schema} initialValues={initialValues} onSubmit={handleSubmit}>
              {({ errors, touched }) => (
                <Form>
                  <div className="mb-5">
                    <div className="mb-3">
                      <label htmlFor="inputName" className="form-label">
                        Importer&apos;s name
                      </label>
                      <Field type="text" name="name" placeholder="Ex. John Doe" className={`form-control ${errors.name && touched.name ? "is-invalid" : ""}`} />
                      {errors.name && <FormError error={errors.name} />}
                    </div>

                    <div className="mb-3">
                      <label htmlFor="inputEmail" className="form-label">
                        Importer&apos;s Email Address
                      </label>
                      <Field
                        placeholder="Ex. john@acme.com"
                        name="email"
                        id="inputEmail"
                        type="email"
                        className={`form-control ${errors.email && touched.email ? "is-invalid" : ""}`}
                      />
                      {errors.email && <FormError error={errors.email} />}
                    </div>

                    <div className="mb-3">
                      <label htmlFor="inputPhone" className="form-label">
                        Importer&apos;s Phone Number
                      </label>
                      <Field
                        placeholder="Ex. +17173064124"
                        name="phoneNumber"
                        type="text"
                        id="inputPhone"
                        className={`form-control ${errors.phoneNumber && touched.phoneNumber ? "is-invalid" : ""}`}
                      />
                      {errors.phoneNumber && <FormError error={errors.phoneNumber} />}
                    </div>

                    <div className="mb-3">
                      <label htmlFor="inputAddress" className="form-label">
                        Importer&apos;s Address
                      </label>
                      <Field
                        placeholder="Ex. 253 Hill Haven Drive, Killeen, TX 76541"
                        name="address"
                        id="inputAddress"
                        type="text"
                        className={`form-control ${errors.address && touched.address ? "is-invalid" : ""}`}
                      />
                      {errors.address && <FormError error={errors.address} />}
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-center gap-2">
                    <Link
                      className="btn btn-outline-secondary text-uppercase fw-bold"
                      to="/dashboard/certificate-of-origin/generate/producer-data/"
                      state={{ ...location.state }}
                    >
                      Cancel & Go back
                    </Link>
                    <button type="submit" className="btn btn-primary text-uppercase fw-bold">
                      Save & Continue
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </div>
        <div className="col-lg-2" />
      </div>
    </div>
  );
}
